module.exports = __webpack_public_path__ + "img/logo-leben-mit-schizophrenie.434a2d2f.svg";